import { lazy } from 'react';

export const UpdateTariffFeaturePageLazy = lazy(() => import('./UpdateTariffFeaturePage'));
